module.exports = __webpack_public_path__ + "img/projects1.5b007e33.jpg";